import React from 'react';
import { useMarketContext } from '../context/MarketDataContext';
import BreakoutTables from '../components/BreakoutTables';
import ShortTickers from '../components/ShortTickers';

export default function ShortAndLong() {
  const { tickers, shortSymbols, breakoutLongs, breakoutShorts, mainBreakoutLongs, mainBreakoutShorts } = useMarketContext();

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Short & Long</h1>
      </div>

      <BreakoutTables
        premarketLongs={breakoutLongs}
        premarketShorts={breakoutShorts}
        mainLongs={mainBreakoutLongs}
        mainShorts={mainBreakoutShorts}
        tickers={tickers}
      />

      <ShortTickers tickers={tickers} shortSymbols={shortSymbols} />
    </div>
  );
}
